<template>
  <div id="admin-export-Log">
    <div class="row">
      <div class="col-12 mb-1">
        <h4 class="text-blue"><b><u>Export Log</u></b></h4>
      </div>
      <div class="col-12 mb-3">
        <b-form inline @submit.stop.prevent="exportLog">
          <label class="mr-2" for="inline-form-custom-select-pref">From Date:</label>
          <b-form-input type="date" class="mr-2" v-model="form.fromDate"></b-form-input>
          <label class="mr-2" for="inline-form-custom-select-pref">To Date:</label>
          <b-form-input type="date" class="mr-2" v-model="form.toDate"></b-form-input>
          <b-button type="submit" variant="primary"><i class="fas fa-download"></i> Export</b-button>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
  export default {
    data() {
      return {
        form: {
          fromDate: '',
          toDate: ''
        }
      }
    },
    mounted() {
    },
    methods: {
      exportLog() {
        let loading = this.$loading.show()
        const fromDate = this.form.fromDate ? moment(this.form.fromDate).format('YYYY-MM-DD') : ''
        const toDate = this.form.toDate ? moment(this.form.toDate).format('YYYY-MM-DD') : ''
        this.$http.get(this.$app.baseURL + this.$path.searchLog + '?from=' + fromDate + '&to=' + toDate , { responseType: 'blob' }).then(
          response => {
            loading.hide()
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = 'API_Log'
            link.click()
            URL.revokeObjectURL(link.href)
          }, () => {
            loading.hide()
          }
        )
      }
    }
  }
</script>

<style scoped>
  label#fromDate {
    border: none;
  }
</style>